/*
  IMPORTANT - order of days must match in these two config objects, otherwise generated view will be out of sync
*/

export const IMPRESSIONS_CHOICES = [500, 1000, 2000, 3000, 4000, 5000, 7500, 10000, 12500, 15000]

export const DEFAULT_ACTIVITY_CONFIG = [
  {
    Day: 'sunday',
    Active: true,
    ImpressionsOrdered: 3000,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
  {
    Day: 'monday',
    ImpressionsOrdered: 3000,
    Active: true,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
  {
    Day: 'tuesday',
    ImpressionsOrdered: 3000,
    Active: true,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
  {
    Day: 'wednesday',
    ImpressionsOrdered: 3000,
    Active: true,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
  {
    Day: 'thursday',
    ImpressionsOrdered: 3000,
    Active: true,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
  {
    Day: 'friday',
    ImpressionsOrdered: 3000,
    Active: true,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
  {
    Day: 'saturday',
    ImpressionsOrdered: 3000,
    Active: true,
    ActiveHours: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
  },
]

export const DEFAULT_FREEMIUM_ACTIVITY_CONFIG = [
  {
    Day: 'sunday',
    Active: true,
    ImpressionsOrdered: 300,
    ActiveHours: [17, 18, 19, 20, 21],
  },
  {
    Day: 'monday',
    ImpressionsOrdered: 300,
    Active: true,
    ActiveHours: [17, 18, 19, 20, 21],
  },
  {
    Day: 'tuesday',
    ImpressionsOrdered: 300,
    Active: true,
    ActiveHours: [17, 18, 19, 20, 21],
  },
  {
    Day: 'wednesday',
    ImpressionsOrdered: 300,
    Active: true,
    ActiveHours: [17, 18, 19, 20, 21],
  },
  {
    Day: 'thursday',
    ImpressionsOrdered: 300,
    Active: true,
    ActiveHours: [17, 18, 19, 20, 21],
  },
  {
    Day: 'friday',
    ImpressionsOrdered: 300,
    Active: true,
    ActiveHours: [17, 18, 19, 20, 21],
  },
  {
    Day: 'saturday',
    ImpressionsOrdered: 300,
    Active: true,
    ActiveHours: [17, 18, 19, 20, 21],
  },
]

export const DEFAULT_BUDGET_CONFIG = [
  {
    Day: 'sunday',
    BudgetInCents: 1000,
  },
  {
    Day: 'monday',
    BudgetInCents: 1000,
  },
  {
    Day: 'tuesday',
    BudgetInCents: 1000,
  },
  {
    Day: 'wednesday',
    BudgetInCents: 1000,
  },
  {
    Day: 'thursday',
    BudgetInCents: 1000,
  },
  {
    Day: 'friday',
    BudgetInCents: 1000,
  },
  {
    Day: 'saturday',
    BudgetInCents: 1000,
  },
]

export const DEFAULT_AUDIENCE_CONFIG = {
  Languages: [],
  Work: { Industries: [], SmallBusinessOwners: false },
  Interests: {
    HobbiesAndActivities: [],
    Entertainment: [],
    FoodAndDrink: [],
    ShoppingAndFashion: [],
    Technology: { ConsumerType: [], Computers: [], ConsumerElectronics: [] },
  },
  Ages: [],
  Genders: [],
  LifeEvents: [],
  Parents: [],
  Income: [],
}
